import React from 'react'
import logo from '../logo.svg'
import '../App.css'
import {useSelector} from "react-redux";


function CreateReactApp () {
  const changes= useSelector((state)=> state.changes)
  const {layers} = changes
    return (




    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
            {}
        </p>{layers.map((o)=> o.href)}
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  )
}


export default CreateReactApp



// WEBPACK FOOTER //
// ./src/containers/CreateReactApp.js